import * as angular from 'angular';

import { ComponentDefinition } from '../../models';
import { IRootScope } from '../../IRootScope';
import { IMailingJobService, ILoggerService, IRecipientsHelper, IRecipientsComponentViewModel } from '../../services';
import { toggleEditMode } from '../../common/';

class EditEmailStateController implements angular.IComponentController {
    isLoading: boolean;
    loadingMessage: string;
    selectedItem: any;
    isEditMode: boolean;
    recipients: IRecipientsComponentViewModel;

    static $inject = [
        '$scope',
        '$rootScope',
        '$stateParams',
        'recipientsHelper',
        'mailingJobService',
        'loggerService'
    ];

    constructor(
        private _$scope: angular.IScope,
        private _$rootScope: IRootScope,
        private _$stateParams: angular.ui.IStateParamsService,
        private _recipientsHelper: IRecipientsHelper,
        private _mailingJobService: IMailingJobService,
        private _loggerService: ILoggerService
    ) {
    }

    $onInit() {
        if (!this._$rootScope.isEditMode) {
            this._$rootScope.$broadcast(toggleEditMode, true);
        }
        this.isEditMode = true;
        this.isLoading = true;
        this._mailingJobService
            .getByGuid(this._$stateParams['guid'])
            .then(data => this.selectedItem = data)
            .finally(() => this.isLoading = false);

        this._$scope.$on('cancel', () => {
            this.isLoading = true;
            this._mailingJobService
                .refresh(this._$stateParams['guid'])
                .then(data => this.selectedItem = data)
                .finally(() => this.isLoading = false);
        });

        this._recipientsHelper
            .loadRecipients()
            .then(r => this.recipients = r);
    }

    testSend() {
        this.isLoading = true;
        this._mailingJobService.test(this.selectedItem)
            .then(data => {
                if (!!data) {
                    this._loggerService.logSuccess('E-mail successfully sent. Check your mailbox!');
                } else {
                    this._loggerService.logError('Failed to send e-mail.');
                }
            })
            .finally(() => {
                this.isLoading = false;
            });
    }
}

export const wtEditEmailState: ComponentDefinition = {
    componentId: 'wtEditEmailState',
    controller: EditEmailStateController,
    template: require('./editEmailState.component.html'),
    controllerAs: 'vm',
    bindings: {

    }
};